<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col>
          <b-card>
            <label for="items" class="text-primary font-weight-bolder mb-1"
              >Items</label
            >
            <b-row>
              <b-col cols="3">
                <b-form-group label="Purchase" label-for="purchase">
                  <v-select
                    id="purchase"
                    v-model="form.selectedPurchase"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsPurchase"
                    placeholder="Select 1 Purchase"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedPurchase"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedPurchase }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Date" label-for="date">
                  <flat-pickr
                    id="date"
                    v-model="form.date"
                    class="form-control"
                    placeholder="Date"
                    :config="{ dateFormat: 'd-m-Y' }"
                    required
                  />
                  <!-- <p>Value: '{{ form.date }}'</p> -->
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Amount" label-for="amount">
                  <cleave
                    id="amount"
                    placeholder="Amount"
                    v-model="form.amount"
                    class="form-control"
                    :raw="false"
                    :options="options.number"
                    required
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col>
                <label for="items" class="text-primary font-weight-bolder mb-1"
                  >Items</label
                >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  v-b-modal.modal-add
                  class="float-right mb-2"
                  >Add Item
                </b-button>
              </b-col>
            </b-row>
            <b-modal
              id="modal-add"
              ref="modal-add"
              centered
              title="Add Item"
              hide-footer
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Product" label-for="product">
                    <v-select
                      id="product"
                      v-model="form2.selectedProduct"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form2.optionsProduct"
                      :disabled="form.selectedPurchase === null ? true : false"
                      placeholder="Select 1 Product"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <!-- Selected: <strong>{{ form2.selectedProduct }}</strong> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Qty" label-for="qty">
                    <b-form-input
                      id="qty"
                      type="number"
                      placeholder="Qty"
                      v-model="form2.qty"
                      :disabled="form2.selectedProduct === null ? true : false"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="Description"
                    label-for="description_item"
                  >
                    <b-form-textarea
                      id="description_item"
                      placeholder="Description"
                      v-model="form2.description"
                      :disabled="form2.selectedProduct === null ? true : false"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="my-1"
                    @click="addItemToTable()"
                    block
                    :disabled="form.selectedVendor === null ? true : false"
                  >
                    Add Item
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>
            <b-row>
              <b-col>
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">{{
                        formatRupiah(props.row.price)
                      }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                      <b-badge :variant="statusVariant(props.row.status)">
                        <span v-if="props.row.status === 1">On Process</span>
                        <span v-if="props.row.status === 2">Returned</span>
                        <span v-else>Finished</span>
                      </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            @click="
                              deleteItemFromTable(props.row.originalIndex)
                            "
                          >
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            block
            @click="validation()"
            :disabled="rows.length === 0 ? true : false"
          >
            Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
    BModal,
    VBModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        selectedPurchase: null,
        optionsPurchase: [],
        date: null,
        amount: null,
        description: "",
      },
      form2: {
        return_id: null,
        selectedProduct: null,
        optionsProduct: [],
        qty: null,
        description: "",
        price: null,
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Product",
          field: "product_name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Price",
          field: "price",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-primary",
        3: "light-success",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  watch: {
    "form.selectedPurchase": function (data) {
      this.rows.splice(0);
      this.getProduct(data.value);
    },
    rows: function (data) {
      var $datas = data;
      var i;
      var $price = 0;
      for (i = 0; i < $datas.length; i++) {
        $price += $datas[i].price;
      }
      this.form.amount = 0;
      this.form.amount = $price;
    },
  },
  created() {
    this.getPurchase();
  },
  methods: {
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    getPurchase() {
      this.$http.get("procurement/purchases").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].code,
          };
          // console.log($data)
          this.form.optionsPurchase.push($data);
        }
        // console.log(this.form.optionsPurchase)
      });
    },
    getProduct($id) {
      this.$http
        .get("procurement/purchases/" + $id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          this.form2.optionsProduct.splice(0);
          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            var $data = {
              value: datas[i].product_id,
              text: datas[i].product_name,
              price: datas[i].price,
            };
            // console.log($data)
            this.form2.optionsProduct.push($data);
          }
          // console.log(this.form2.optionsProduct)
        });
    },
    addItemToTable() {
      this.$refs["modal-add"].hide();
      if (this.form2.selectedProduct === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Product field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.qty === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Qty field is required",
            variant: "warning",
          },
        });
      } else if (this.form2.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else {
        var $data = {
          product_id: this.form2.selectedProduct.value,
          product_name: this.form2.selectedProduct.text,
          qty: this.form2.qty,
          price: this.form2.selectedProduct.price * this.form2.qty,
          description: this.form2.description,
        };
        this.rows.push($data);
        this.form2.selectedProduct = null;
        this.form2.qty = null;
        this.form2.description = "";
        this.form2.price = null;
      }
    },
    deleteItemFromTable(index) {
      this.rows.splice(index, 1);
    },
    validation() {
      if (this.form.selectedProduct === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Product field is required",
            variant: "warning",
          },
        });
      } else if (this.form.date === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Date field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else {
        this.addReturn();
      }
    },
    addReturn() {
      if (this.form.selectedPurchase !== null) {
        var $purchaseID = this.form.selectedPurchase.value;
      }
      this.$http
        .post("procurement/return/add", {
          code: this.form.code,
          purchase_id: $purchaseID,
          date: this.form.date,
          description: this.form.description,
        })
        .then((response) => {
          this.form2.return_id = response.data.data.id;
          var $datas = this.rows;
          var i;
          for (i = 0; i < $datas.length; i++) {
            var $data = {
              return_id: this.form2.return_id,
              product_id: $datas[i].product_id,
              qty: $datas[i].qty,
              description: $datas[i].description,
            };
            // console.log($data)
            this.addReturnItems($data);
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Return",
              variant: "success",
            },
          });
          setTimeout(function () {
            location.href = "/procurement/procurement-return";
          }, 2000);
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    addReturnItems($data) {
      this.$http
        .post("procurement/return/item/add", $data)
        .then((response) => {
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>